(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define("TextTyping", ['jquery/jquery-3.2.1.js', 'typed/typed.js'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(require('jquery/jquery-3.2.1.js'), require('typed/typed.js'));
    } else {
        // Browser globals (root is window)
        root.TextTyping = factory(root.$, root.Typed);
    }
}(typeof self !== 'undefined' ? self : this, function ($, Typed) {

    var typed, elementId, mainOptions;

    var init = function (itemId, options) {

        elementId = itemId;
        mainOptions = options;

        if (document.getElementById(elementId)) {
            typed = new Typed('#' + elementId, mainOptions);

            typedTextUnderline();
        }
    };

    var typedTextUnderline = function () {
        $("#" + elementId).on('ChangeContent', function () {

            if ($(this).hasClass('underline')) {
                $(this).removeClass('underline');
            }

            if ($(this).text()) {
                if (!$(this).hasClass('underline')) {
                    $(this).addClass('underline');
                }
            }
        });
    };

    var typeStart = function () {
        if (typed) {
            typed.start();
        }
    };

    var typeStop = function () {
        if (typed) {
            typed.stop();
        }

    };

    return {
        init: init,
        typeStart: typeStart,
        typeStop: typeStop
    };

}));